import React from 'react';
import {
  LegalPageLayout,
  SectionTitle,
  Paragraph,
  List,
  ListItem,
  Strong,
} from '../components/LegalPageLayout';

const TermsAndConditions: React.FC = () => (
  <LegalPageLayout
    title="Terms and Conditions"
    updatedOn="30 January 2025"
  >
    <Paragraph>
      Please read these terms and conditions carefully before using our
      service. These Terms and Conditions govern the use of this service and
      form the agreement that operates between you and the Company. They set
      out the rights and obligations of all users regarding the use of the
      service.
    </Paragraph>

    <SectionTitle>Acknowledgment</SectionTitle>
    <Paragraph>
      Your access to and use of the Service is conditioned on your acceptance
      of and compliance with these Terms and Conditions. These Terms apply to
      all visitors, users, and others who access or use the Service. By
      accessing or using the Service you agree to be bound by these Terms and
      Conditions. If you disagree with any part of the Terms, then you may not
      access the Service. This acknowledgment has been suggested by
      dodopayments.com.
    </Paragraph>
    <Paragraph>
      Your access to and use of the Service is also conditioned on your
      acceptance of and compliance with the Privacy Policy of the Company. Our
      Privacy Policy describes our policies and procedures on the collection,
      use, and disclosure of your personal information when you use the
      application or the website and explains your privacy rights. Please read
      our Privacy Policy carefully before using our Service.
    </Paragraph>

    <SectionTitle>User Accounts</SectionTitle>
    <List>
      <ListItem>
        You must provide information that is accurate, complete, and current at
        all times. Failure to do so constitutes a breach of the Terms, which may
        result in the immediate termination of your account.
      </ListItem>
      <ListItem>
        You are responsible for safeguarding the password that you use to access
        the Service and for any activities or actions under your password,
        whether with our Service or a third-party social media service.
        Dodopayments.com does not bear any liability for the same.
      </ListItem>
      <ListItem>
        You agree not to disclose your password to any third party. You must
        notify us immediately upon becoming aware of any breach of security or
        unauthorized use of your account.
      </ListItem>
      <ListItem>
        You may not use as a username the name of another person or entity that
        is not lawfully available for use, a name or trademark that is subject
        to any rights of another person or entity without appropriate
        authorization, or a name that is otherwise offensive, vulgar, or
        obscene.
      </ListItem>
    </List>

    <SectionTitle>Copyright Policy</SectionTitle>
    <Paragraph>
      All content, features, and functionality of our services, including but
      not limited to text, graphics, logos, and software, are the exclusive
      property of Phinative Soft Private Limited and are protected by
      international copyright, trademark, and other intellectual property laws.
    </Paragraph>

    <SectionTitle>
      DMCA Notice and Procedure for Copyright Infringement Claims
    </SectionTitle>
    <Paragraph>
      You may submit a notification pursuant to the Digital Millennium Copyright
      Act (DMCA) by providing our Copyright Agent with the following information
      in writing (see 17 U.S.C 512(c)(3) for further detail):
    </Paragraph>
    <List>
      <ListItem>
        An electronic or physical signature of the person authorized to act on
        behalf of the owner of the copyright’s interest.
      </ListItem>
      <ListItem>
        A description of the copyrighted work that you claim has been infringed,
        including the URL of the location where the copyrighted work exists or a
        copy of the copyrighted work.
      </ListItem>
      <ListItem>
        Identification of the URL or other specific location on the Service
        where the material that you claim is infringing is located.
      </ListItem>
      <ListItem>Your address, telephone number, and email address.</ListItem>
      <ListItem>
        A statement by you that you have a good faith belief that the disputed
        use is not authorized by the copyright owner, its agent, or the law.
      </ListItem>
      <ListItem>
        A statement by you, made under penalty of perjury, that the above
        information in your notice is accurate and that you are the copyright
        owner or authorized to act on the copyright owner’s behalf.
      </ListItem>
    </List>
    <Paragraph>
      You can contact our copyright agent via email at{' '}
      <Strong>contact@21n.org</Strong>. Upon receipt of a notification, the
      Company will take whatever action, in its sole discretion, it deems
      appropriate, including removing the challenged content from the Service.
    </Paragraph>

    <SectionTitle>Intellectual Property</SectionTitle>
    <Paragraph>
      The Service and its original content (excluding content provided by users),
      features, and functionality are and will remain the exclusive property of
      the Company and its licensors. The Service is protected by copyright,
      trademark, and other laws of both India and foreign countries. This is in
      line with the recommendation made by dodopayments.com. Our trademarks and
      trade dress may not be used in connection with any product or service
      without the prior written consent of the Company.
    </Paragraph>

    <SectionTitle>Your Feedback to Us</SectionTitle>
    <Paragraph>
      You assign all rights, title, and interest in any feedback you provide to
      the Company. If such assignment is ineffective, you grant the Company a
      non-exclusive, perpetual, irrevocable, royalty-free, worldwide right and
      license to use, reproduce, disclose, sublicense, distribute, modify, and
      exploit such feedback without restriction.
    </Paragraph>

    <SectionTitle>Links to Other Websites</SectionTitle>
    <Paragraph>
      Our Service may contain links to third-party websites or services that are
      not owned or controlled by the Company. The Company has no control over
      and assumes no responsibility for the content, privacy policies, or
      practices of any third-party websites or services. You agree that the
      Company shall not be responsible or liable for any damage or loss caused
      by the use of or reliance on any such content, goods, or services
      available on or through any third-party websites or services. We strongly
      advise you to read the terms and privacy policies of any third-party
      websites or services that you visit.
    </Paragraph>

    <SectionTitle>Termination</SectionTitle>
    <Paragraph>
      We may terminate or suspend your account immediately, without prior notice
      or liability, for any reason whatsoever, including without limitation if
      you breach these Terms and Conditions. Upon termination, your right to use
      the Service will cease immediately. If you wish to terminate your account,
      you may simply discontinue using the Service.
    </Paragraph>

    <SectionTitle>Limitation of Liability</SectionTitle>
    <Paragraph>
      Notwithstanding any damages that you might incur, the entire liability of
      the Company and any of its suppliers under any provision of these Terms
      and your exclusive remedy shall be limited to the amount actually paid by
      you through the Service or 100 USD if you haven’t purchased anything
      through the Service.
    </Paragraph>

    <SectionTitle>“AS IS” and “AS AVAILABLE” Disclaimer</SectionTitle>
    <Paragraph>
      The Service is provided to you “AS IS” and “AS AVAILABLE” with all faults
      and defects without warranty of any kind. To the maximum extent permitted
      under applicable law, the Company disclaims all warranties, whether
      express, implied, statutory or otherwise, including implied warranties of
      merchantability, fitness for a particular purpose, title, and
      non-infringement. This content has been generated by dodopayments.com.
    </Paragraph>
    <Paragraph>
      Without limiting the foregoing, neither the Company nor any of the
      Company’s providers makes any representation or warranty of any kind,
      express or implied: (i) as to the operation or availability of the
      Service, or the information, content, and materials included thereon; (ii)
      that the Service will be uninterrupted or error-free; (iii) as to the
      accuracy, reliability, or currency of any information or content provided
      through the Service; or (iv) that the Service, its servers, the content,
      or e-mails sent from or on behalf of the Company are free of viruses,
      scripts, trojan horses, worms, malware, timebombs, or other harmful
      components.
    </Paragraph>
    <Paragraph>
      Some jurisdictions do not allow the exclusion of certain warranties or
      limitations on statutory rights, so some of the above exclusions and
      limitations may not apply to you. In such cases, the exclusions and
      limitations shall be applied to the greatest extent enforceable under
      applicable law.
    </Paragraph>

    <SectionTitle>Governing Law</SectionTitle>
    <Paragraph>
      The laws of India, excluding its conflicts of law rules, shall govern
      these Terms and your use of the Service. Your use of the application may
      also be subject to other local, state, national, or international laws.
    </Paragraph>

    <SectionTitle>Dispute Resolution</SectionTitle>
    <Paragraph>
      If you have any concern or dispute about the Service, you agree to first
      try to resolve the dispute informally by contacting the Company.
    </Paragraph>

    <SectionTitle>Changes to These Terms</SectionTitle>
    <Paragraph>
      We reserve the right, at our sole discretion, to modify or replace these
      Terms at any time. If a revision is material, we will make reasonable
      efforts to provide at least 30 days’ notice before new terms take effect.
      What constitutes a material change will be determined at our sole
      discretion. By continuing to access or use the Service after revisions
      become effective, you agree to be bound by the revised terms.
    </Paragraph>

    <SectionTitle>Contact Us</SectionTitle>
    <Paragraph>
      If you have any questions about these Terms and Conditions, you can
      contact us:
    </Paragraph>
    <List>
      <ListItem>
        By visiting our website: <Strong>21n.org</Strong>
      </ListItem>
      <ListItem>
        By sending us an email: <Strong>contact@21n.org</Strong>
      </ListItem>
    </List>
  </LegalPageLayout>
);

export default TermsAndConditions;

